import { getJwtToken } from "@infinitaslearning/il.authentication.avatar"
import jwtDecode from "jwt-decode"
import { useEffect, useMemo, useState } from "react"
import type { JwtToken } from "./../redux/user/user.types"

export interface IUseJwtToken {
  token: string | undefined
  isTeacher: boolean
}

export function useJwtToken(): IUseJwtToken {
  const [jwtToken, setJwtToken] = useState<string>()
  useEffect(() => {
    const fetchJwt = async () => {
      const token = await getJwtToken()
      setJwtToken(token)
    }

    fetchJwt()
  }, [])

  const isTeacher: boolean = useMemo(() => {
    if (!jwtToken) return false
    const { is_teacher }: JwtToken = jwtDecode(jwtToken)
    return is_teacher === "true"
  }, [jwtToken])

  return { token: jwtToken, isTeacher }
}
